import { render, staticRenderFns } from "./CertificateFilter.vue?vue&type=template&id=2f53b7d2&"
import script from "./CertificateFilter.vue?vue&type=script&lang=js&"
export * from "./CertificateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports